<template>
  <div :class="['', $store.state.common.theme!=3?'wrapper':'wrapper_theme_3']" >
    <div class="formBox" v-if="hasPanel && isloaded">
      <div class="tabBox" v-if="$store.state.common.theme!=3">
        <span :class="['tabText', activeTab ? 'activeTab' : '']" @click="activeTab = 1">邀请访客</span>
        <span :class="['tabText', activeTab ? '':'activeTab']" @click="activeTab = 0">拜访公司</span>
      </div>
      <div class="tabBox" v-if="$store.state.common.theme==3">
        <span :class="['tabText_theme_3', activeTab ? 'activeTab_theme_3' : '']" @click="activeTab = 1">邀请访客</span>
        <span :class="['tabText_theme_3', activeTab ? '':'activeTab_theme_3']" @click="activeTab = 0">拜访公司</span>
      </div>
      <div class="remarksBox" v-if="$store.state.common.theme!=3">
        <span class="inviteText" v-if="activeTab">入驻企业员工邀请外部访客</span>
        <span class="visitText" v-else>外部访客预约拜访入驻公司</span>
      </div>
      <div class="remarksBox" v-if="$store.state.common.theme==3">
        <div class="remarkView"  v-if="activeTab">
          <div class="remarkText" >访客自助服务系统</div>
          <div class="remarkText2" >访客登记</div>
        </div>
        <div class="remarkView"  v-else>
          <div class="remarkText" >拜访公司自助服务系统</div>
          <div class="remarkText2" >公司登记</div>
        </div>

      </div>
      <div :class="['', $store.state.common.theme!=3?'form':'form_theme_3']"  >
        <template v-for="item in regList">
          <div
            @click="searchPerson"
            class="nameBox"
            v-if="item.regKey === 'examine_user_name'"
            :key="item.regKey"
          >
            <div class="nameCardLeft">
              <span class="xin">*</span>
              <span class="label">{{item.regKey | labelFilter(activeTab)}}</span>
            </div>
            <div class="nameBoxRight" v-if="!userInfo">
              <span class="placeholder">请选择</span>
              <img class="yjt" src="../../assets/images/icon_indicator_next.png" />
            </div>
            <div class="nameCardRight" v-else>
              <div class="nameCardRightLeft">
                <span class="value">{{userInfo.userName}}</span>
                <div class="companyCard">
                  <span class="companyLabel">公司</span>
                  <span class="companyText">{{companyName}}</span>
                </div>
              </div>
              <img class="yjt" src="../../assets/images/icon_indicator_next.png" />
            </div>
          </div>
          <!-- 拜访公司 -->
          <div
            @click="searchCompanyName"
            class="nameBox"
            v-if="item.regKey === 'visitor_company' && (!hasPerson)"
            :key="item.regKey"
          >
            <div class="nameBoxLeft">
              <span class="xin">*</span>
              <span class="label">{{item.regKey | labelFilter(activeTab)}}</span>
            </div>
            <div class="nameBoxRight">
              <span class="placeholder" v-if="!companyName">请选择</span>
              <span class="value" v-else>{{companyName}}</span>
              <img class="yjt" src="../../assets/images/icon_indicator_next.png" />
            </div>
          </div>
          <!-- 拜访楼层 -->
          <div
            class="nameBox"
            v-if="item.regKey === 'visitor_floor' && item.regValue"
            @click="changeSelect(floorList,'visitor_floor')"
            :key="item.regKey"
          >
            <div class="nameBoxLeft">
              <span class="xin">*</span>
              <span class="label">{{item.regKey | labelFilter(activeTab)}}</span>
            </div>
            <div class="nameBoxRight">
              <span class="placeholder" v-if="!item.regValue">请选择{{item.regName}}</span>
              <span class="value" v-else>{{item.regValue}}</span>
              <img class="yjt" src="../../assets/images/icon_indicator_next.png" />
            </div>
          </div>
          <!-- 拜访日期 -->
          <div
            @click="pickTime"
            class="nameBox"
            v-if="item.regKey === 'visitor_date'"
            :key="item.regKey"
          >
            <div class="nameBoxLeft">
              <span class="xin">*</span>
              <span class="label">{{item.regKey | labelFilter(activeTab)}}</span>
            </div>
            <div class="nameBoxRight">
              <span class="placeholder" v-if="!item.regValue || item.regValue == 0">请选择</span>
              <span class="value" v-else>{{item.regValue}}</span>
              <img class="yjt" src="../../assets/images/icon_indicator_next.png" />
            </div>
          </div>
          <!-- 来访事由 -->
          <div
            @click="changeSelect(dictList,'visitor_type')"
            class="nameBox"
            v-if="item.regKey === 'visitor_type'"
            :key="item.regKey"
          >
            <div class="nameBoxLeft">
              <span class="xin">*</span>
              <span class="label">{{item.regKey | labelFilter(activeTab)}}</span>
            </div>
            <div class="nameBoxRight">
              <span class="placeholder" v-if="!item.regValue">请选择</span>
              <span class="value" v-else>{{item.regValue}}</span>
              <img class="yjt" src="../../assets/images/icon_indicator_next.png" />
            </div>
          </div>
          <!-- 证件类型 -->
          <div class="nameBox" v-if="item.regKey === 'visitor_id_type'" :key="item.regKey">
            <div
              class="nameBoxLeft borderRight"
              @click="changeSelect(idTypeList,'visitor_id_type')"
            >
              <span class="xin">*</span>
              <span class="label">{{item.regValue}}</span>
              <img class="yjt" src="../../assets/images/icon_indicator_next.png" />
            </div>
            <div class="nameBoxRight">
              <input class="input" type="text" placeholder="证件号码" @blur="blur" v-model.trim="visitorId" />
            </div>
          </div>
          <!-- 访客电话 -->
          <div class="nameBox" v-if="item.regKey === 'visitor_mobile'" :key="item.regKey">
            <div class="nameBoxLeft">
              <span class="xin">*</span>
              <span class="label">{{item.regKey | labelFilter(activeTab)}}</span>
            </div>
            <div class="nameBoxRight">
              <input
                class="input"
                type="tel"
                :placeholder="item.regName | place"
                v-model="item.regValue"
                 @blur="blur"
              />
            </div>
          </div>
          <!-- 访客人脸 -->
          <div class="faceBox" v-if="item.regKey === 'visitor_face_url'" :key="item.regKey">
            <div class="nameBoxLeft">
              <span class="xin"></span>
              <span class="label">访客人脸</span>
              <!-- <span class="label">{{item.regKey | labelFilter(activeTab)}}</span> -->
            </div>
            <div class="faceBoxRight">
               <div class="imageBg" >
                  <img @click="chooseImg" v-if="imageUrl" class="paiIcon" :src='imageUrl'/>
                  <img v-else @click="chooseImg" class="paiIcon" src='../../assets/images/icon_addphoen.jpg'/>
               </div>
            </div>
          </div>
          <!-- 其他  -->
          <div
            class="nameBox"
            v-if="item.regKey !== 'examine_user_name' && item.regKey !== 'visitor_floor' && item.regKey !== 'visitor_mobile' && item.regKey !== 'visitor_date'
            && item.regKey !== 'visitor_type' && item.regKey !== 'visitor_id_type' && item.regKey !== 'visitor_company' && item.regKey !=='visitor_face_url'
            && item.regKey !== 'visitor_id' && item.regKey !== 'visitor_arrive_wh' && item.regKey !== 'visitor_is_fever' && item.regKey !== 'visitor_is_mask'"
            :key="item.regKey"
          >
            <div class="nameBoxLeft">
              <span class="xin">*</span>
              <span class="label">{{item.regKey | labelFilter(activeTab)}}</span>
            </div>
            <div class="nameBoxRight">
              <input
                class="input"
                :type="item.regKey != 'visitor_num'?'text':'number'"
                :placeholder="item.regKey | labelFilter(activeTab) | place"
                v-model.trim="item.regValue"
                 @blur="blur"
              />
            </div>
          </div>
          <!-- 疫情 -->
          <div
            class="nameBox nameBox_flex"
            v-if="item.regKey == 'visitor_arrive_wh' || item.regKey == 'visitor_is_fever' || item.regKey == 'visitor_is_mask'"
            :key="item.regKey"
          >
            <div class="nameBoxLeft">
              <span class="xin">*</span>
              <span class="label">{{item.regName}}</span>
            </div>
            <div class="nameBoxRight">
              <yd-radio-group v-model="item.regValue" color="#1740da" style="line-height:20px;">
                <yd-radio val="是"></yd-radio>
                <yd-radio val="否"></yd-radio>
            </yd-radio-group>
            </div>
          </div>
        </template>
      </div>
      <div  v-if="$store.state.common.theme!=3" class="historyView">
        <div class="goHistory" @click="goVisitingRecords">查看拜访记录</div>
        <div class="goHistory" @click="goHistory">查看历史记录</div>
      </div>
      
      <div v-if="$store.state.common.theme==3" class="bottom_box_theme_3">
        <div class="remarkView"  v-if="activeTab">
          <div class="remarkText" >入驻企业员工邀请外部访客</div>
        </div>
        <div class="remarkView"  v-else>
          <div class="remarkText" >外部访客预约拜访入驻公司</div> 
        </div>
        <div class="historyView">
          <div class="goHistory_theme_3" @click="goVisitingRecords">查看拜访记录</div>
          <div class="goHistory_theme_3" @click="goHistory">查看历史记录</div>
        </div>
       

      </div>
    </div>
    <!-- 没有数据 -->
    <div class="no_mess" v-if="!hasPanel && isloaded">
      <p>{{common.marketInfo.marketName}}项目尚未配置</p>
      <p class="history_text" @click="goHistory">查看历史记录</p>
      <img src="../../assets/images/fangke.jpg" />
    </div>
    <mt-popup v-model="popupVisible" position="bottom" class="popupBox">
      <mt-picker
        class="picker"
        :slots="dataList"
        :visible-item-count="5"
        :show-toolbar="true"
        :item-height="44"
        ref="picker"
      >
        <div class="picker_wrap">
          <div class="picker_btn" @click="popupVisible=false">取消</div>
          <div class="picker_btn2" @click="handleConfirm">确认</div>
        </div>
      </mt-picker>
    </mt-popup>
    <mt-datetime-picker
      ref="datetime"
      type="datetime"
      :value="visitPickerDate"
      :start-date="visitPickerStartDate"
      year-format="{value}年"
      month-format="{value}月"
      date-format="{value}日"
      hour-format="{value}时"
      minute-format="{value}分"
      @confirm="dateChange"
    ></mt-datetime-picker>
    <footer class="footer_box button" v-if="hasPanel && isloaded">
      <mt-button @click="insertVisitorReg" :class="['btn_default',$store.state.common.theme!=3?'btn_primary':'btn_primary_theme_3']">发起预约</mt-button>
    </footer>
  </div>
</template>

<script>
import { DatetimePicker } from "mint-ui";
import util from "../../utils/util";
import storage from "../../utils/storage";
import { mapState, mapActions } from "vuex";
import { getVisitorRegByParams, insertVisitorReg ,serversHttp,uploadWapFace } from "../../utils/api";
import wx from 'weixin-js-sdk'
export default {
  name: "fanke",
  components: {
    "mt-datetime-picker": DatetimePicker
  },
  data() {
    return {
      regList: "",
      imageUrl:"",
      dictList: [],
      items: {},
      goNext: false,
      companyName: "",
      type: "",
      userInfo: "",
      Idtype: "",
      idTypeList: [],
      settingId: "",
      visitorId: "",
      hasPerson: false,
      companyInfo: "",
      activeTab: 1, //1邀请 //0拜访
      floorList: [],
      floorObjList: [],
      hasPanel: true,
      isloaded: false,
      dataList: [
        {
          flex: 1,
          values: [],
          className: "slot1",
          textAlign: "center"
        }
      ],
      selectType: "",
      popupVisible: false,
      visitPickerDate: new Date(),
      visitPickerStartDate: new Date(1919, 0, 1),
      hasSelectedVisitDate: false,
      date: util.formatTime(new Date(), 10)
    };
  },
  computed: {
    ...mapState({
      common: state => state.common
    })
  },
  created() {
    setTimeout(() => {
      var isLogin =this.common.userId
      if(isLogin){
        if(this.$route.query.activeTab){
          this.activeTab=Number(this.$route.query.activeTab) 
        }else{
          this.activeTab=1
        }
        this.getVisitorRegByParams();
      }else{
          var activeTab = this.$route.query.activeTab ||1
          this.$router.push({
              path:'/login',
              query:{
                Rurl:`/fanke?activeTab=${activeTab}`
              }
          });
      }
      
    }, 500);
   

   
    
    
  },
  activated() {
    const userInfo = storage.get("userInfo");
    if (userInfo) {
      this.userInfo = JSON.parse(userInfo);
      this.userInfoComputer();
    }
    const companyInfo = storage.get("companyInfo");
    if (companyInfo) {
      this.companyInfo = JSON.parse(companyInfo);
      this.companyComputer();
    }
  },
  methods: {
    blur(){
      setTimeout(function(){
        var scrollHeight = document.documentElement.scrollTop || document.body.scrollTop || 0;
        window.scrollTo(0, Math.max(scrollHeight - 1, 0));
      }, 100);
    },
    dateChange(val) {
      const selectedDate = util.formatTime(val, 10);
      this.date = selectedDate;
      this.hasSelectedVisitDate = true;
      let regList = this.regList;
      for (var index in regList) {
        if (regList[index].regKey === "visitor_date") {
          regList[index].regValue = selectedDate;
        }
      }
      // this.cango()
    },
    handleConfirm() {
      this.popupVisible = false;
      let regList = this.regList;
      // 楼层
      if (this.selectType == "visitor_floor") {
        let val = this.$refs.picker.getValues()[0];
        for (var index in regList) {
          if (regList[index].regKey === "visitor_floor") {
            regList[index].regValue = val;
          }
        }
      } else if (this.selectType == "visitor_type") {
        // 拜访事由
        let val = this.$refs.picker.getValues()[0];
        for (var index in regList) {
          if (regList[index].regKey === "visitor_type") {
            regList[index].regValue = val;
          }
        }
      } else if (this.selectType == "visitor_id_type") {
        // 身份类型
        let val = this.$refs.picker.getValues()[0];
        for (var index in regList) {
          if (regList[index].regKey === "visitor_id_type") {
            regList[index].regValue = val;
          }
        }
      }
      // this.regList = regList;
      // console.log(this.regList)
      // this.cango()
    },
    searchPerson() {
      this.$router.push({
        path: `/searchPerson?activeTab=${this.activeTab}`
      });
    },
    goHistory() {
      this.$router.push({
        path: `/visitHistory?activeTab=${this.activeTab}`
      });
    },
    goVisitingRecords(){
      this.$router.push({
        path: `/visitingRecords`
      });
    },
    getVisitorRegByParams(comeClick) {
      console.log('in getVisitorRegByParams') 
      getVisitorRegByParams({
        userId: this.common.userId,
        marketId: this.common.marketInfo.id
      }).then(res => {
        console.log(res);
        if (res.res.code === 10000) {
          this.floorObjList = [];
          this.regList = res.body.regList;
          this.settingId = res.body.setting.id;
          this.date = util.formatTime(new Date(), 10);
          this.hasSelectedVisitDate = false;
          let regList = res.body.regList,

            idTypeList = res.body.idTypeList;
            // var item ={
            //     "id":"20220112",
            //     "sortOrder":7,
            //     "isDrop":0,
            //     "regName":"同行人",
            //     "regularName":"0",
            //     "regType":1,
            //     "regValue":"0",
            //     "regKey":"visitor_peer",
            //     "groupType":2,
            //     "extType":1}
            //  regList.push(item)
          for (let key in regList) {
            if (regList[key].regValue == 0) {
              regList[key].regValue = "";
            }
            if (regList[key].regKey === "visitor_date") {
              regList[key].regValue = this.date;
            }
            if (regList[key].regKey === "examine_user_name") {
              this.hasPerson = true;
            }
            if (regList[key].regKey === "visitor_id_type") {
              regList[key].regValue = idTypeList[0].dictName;
            }
            // 如果是拜访公司,填充名字电话
            if (!this.activeTab) {
              if (regList[key].regKey === "visitor_user_name") {
                regList[key].regValue =
                  this.common.userTenantInfo.userName ||
                  this.common.userInfo.userName;
              }
              if (regList[key].regKey === "visitor_mobile") {
                regList[key].regValue =
                  this.common.userInfo.phone || this.common.userInfo.account;
              }
            }
          }
          if (res.body.dictList) {
            this.dictList = [];
            let dictList = res.body.dictList;
            for (let key in dictList) {
              this.dictList.push(dictList[key].dictName);
            }
          }
          if (res.body.idTypeList) {
            this.idTypeList = [];
            for (let key in idTypeList) {
              this.idTypeList.push(idTypeList[key].dictName);
            }
            this.Idtype = idTypeList[0].dictName;
          }
          if (this.activeTab) {
            if (res.body.examineInfo) {
              this.userInfo = res.body.examineInfo;
              this.userInfoComputer();
            } else if (res.body.companyInfo) {
              this.companyInfo = res.body.companyInfo;
              this.companyComputer();
            } else {
              this.activeTab = 0;
              // 如果是用户点击就显示提示
              if (comeClick) {
                util.showModal(
                  "",
                  "您在" + this.common.marketInfo.marketName + "尚未认证企业？",
                  true,
                  "去认证",
                  () => {
                    this.$router.push({
                      path: "/companyList"
                    });
                  }
                );
              }
            }
          }
        }else{
          this.hasPanel = false
        }
        util.hideLoading();
        //   this.cango()
        this.isloaded = true;
      });
    },
    pickTime() {
      if (!this.hasSelectedVisitDate) {
        this.date = util.formatTime(new Date(), 10);
        this.regList.forEach(item => {
          if (item.regKey === "visitor_date") {
            item.regValue = this.date;
          }
        });
      }
      this.visitPickerDate = new Date(this.date.replace(/-/g, "/"));
      this.$nextTick(() => {
        this.$refs.datetime.open();
      });
    },
    pickItem() {
      var params = {};
      params.options = this.dictList;
      normalPicker.openDialog(params, src => {
        this.type = src;
        let regList = this.regList;
        for (var index in regList) {
          if (regList[index].regKey === "visitor_type") {
            regList[index].regValue = src;
          }
        }
        this.regList = regList;
        //   this.cango()
      });
    },
    pickIdItem() {
      var params = {};
      params.options = this.idTypeList;
      normalPicker.openDialog(params, src => {
        this.Idtype = src;
        let regList = this.regList;
        for (var index in regList) {
          if (regList[index].regKey === "visitor_id_type") {
            regList[index].regValue = src;
          }
        }
        this.regList = regList;
        //   this.cango()
      });
    },
    getValue(e, key) {
      console.log(e);
      let regList = this.regList;
      for (var index in regList) {
        if (regList[index].regKey === key) {
          regList[index].regValue = e.value;
        }
      }
      this.regList = regList;
      // this.cango()
    },
    getVisitorId(e) {
      let regList = this.regList;
      for (var index in regList) {
        if (regList[index].regKey === "visitor_id") {
          regList[index].regValue = e.value;
        }
      }
      this.visitorId = e.value;
      this.regList = regList;
      // this.cango()
    },
    searchCompanyName() {
      this.$router.push({
        path: `/searchCompany?activeTab=${this.activeTab}`
      });
    },
    cango() {
      let regList = this.regList,
        goNext = true;
      for (var index in regList) {
        if (!regList[index].regValue || regList[index].regValue == 0) {
          goNext = false;
        }
      }

      this.goNext = goNext;
    },
    insertVisitorReg() {
      let regList = this.regList,
        params = {
          visitorMode: this.activeTab,
          userId: this.common.userId,
          userName: this.common.userInfo.userName,
          phone: this.common.userInfo.phone || this.common.userInfo.account,
          settingId: this.settingId,
          marketId: this.common.marketInfo.id,
          regList: regList
        };
      console.log(regList);
      if (this.userInfo !== "") {
        params.examineInfo = this.userInfo;
      }
      if (this.companyInfo !== "") {
        params.complaintInfo = this.companyInfo;
      }
      if (this.floorList.length !== 0) {
        for (var index in regList) {
          if (regList[index].regKey === "visitor_floor") {
            this.floorList.forEach((item, j) => {
              if (regList[index].regValue == item) {
                params.buildInfo = this.floorObjList[j];
              }
            });
          }
        }
      }
      let goNext = true,
        myreg = /^1\d{10}$/;
      for (var index in regList) {
        if (regList[index].regKey === "visitor_date") {
          if (!regList[index].regValue) {
            goNext = false;
            let text = this.activeTab ? "来访日期" : "拜访日期";
            util.showToast("请选择" + text);
            return;
          }
        } else if (regList[index].regKey === "visitor_mobile") {
          if (!myreg.test(regList[index].regValue)) {
            goNext = false;
            util.showToast("请输入正确的手机号");
            return;
          }
        } else if (regList[index].regKey === "visitor_id") {
          if (!this.visitorId) {
            goNext = false;
            util.showToast("请输入" + regList[index].regName);
            return;
          } else {
            regList[index].regValue = this.visitorId;
          }
        } else if (regList[index].regKey === "visitor_type") {
          if (!regList[index].regValue) {
            goNext = false;
            let text = this.activeTab ? "来访事由" : "拜访事由";
            util.showToast("请选择" + text);
            return;
          }
        } else if (regList[index].regKey == 'visitor_arrive_wh' || regList[index].regKey == 'visitor_is_fever' || regList[index].regKey == 'visitor_is_mask') {
          if (regList[index].regValue != '是' && regList[index].regValue != '否') {
            goNext = false;
            util.showToast("请选择" + regList[index].regName);
            return;
          }
        //访客人脸不校验
        } else if (regList[index].regKey === "visitor_face_url") {
            console.log("访客人脸不校验")
            if(this.imageUrl){
              regList[index].regValue =this.imageUrl
            }else{
              regList[index].regValue ="NO";
            }
        } else {
          if (!regList[index].regValue && regList[index].regKey != "visitor_floor") {
            goNext = false;
            if (regList[index].regName == "受访人姓名") {
              util.showToast("请选择受访人信息");
            } else {
              util.showToast("请输入" + regList[index].regName);
            }
            return;
          }
        }
      }
      if (!goNext) {
        return;
      }
      util.showLoading("提交中...");
      insertVisitorReg(params).then(res => {
        util.hideLoading();
        if (res.res.code === 10000) {
          this.userInfo = "";
          this.companyName = "";
          this.regList = "";
          this.date = util.formatTime(new Date(), 10);
          this.type = "";
          this.visitorId = "", this.idTypeList = [];
          this.getVisitorRegByParams();
          storage.remove("userInfo");
          storage.remove("companyInfo");
          this.$router.push({
            path: `/visitHistory?activeTab=${this.activeTab}`
          });
        }else if(res.res.code === 10003){
          util.showModal('',res.res.msg,false,'知道了')
        } else {
          util.showToast(res.res.msg);
        }
      });
    },
    changeSelect(data, type) {
      this.popupVisible = true;
      this.dataList[0].values = data;
      this.selectType = type;
    },
    userInfoComputer() {
      let regList = this.regList;
      for (var index in regList) {
        if (regList[index].regKey === "examine_user_name") {
          regList[index].regValue = this.userInfo.userName;
        }
        if (
          regList[index].regKey === "visitor_company" &&
          this.userInfo.company &&
          this.userInfo.company !== ""
        ) {
          this.companyName = this.userInfo.company;
          regList[index].regValue = this.userInfo.company;
        }
        if (regList[index].regKey === "visitor_floor" && this.userInfo.company) {
          this.floorObjList = this.userInfo.buildData || [];
          this.floorList = [];
          for (var i = 0; i < this.floorObjList.length; i++) {
            this.floorList.push(this.floorObjList[i].ld+'_'+this.floorObjList[i].lc);
          }
          console.log(this.floorObjList)
          regList[index].regValue = this.floorList[0] || '';
        }
      }
      this.regList = regList;
      // this.cango()
    },
    companyComputer() {
      let regList = this.regList;
      for (var index in regList) {
        if (regList[index].regKey === "visitor_company") {
          this.companyName = this.companyInfo.companyName;
          regList[index].regValue = this.companyInfo.companyName;
        }
        if (regList[index].regKey === "visitor_floor") {
          this.floorObjList = this.companyInfo.buildData || [];
          this.floorList = []; //地址,楼栋➕楼层
          for (var i = 0; i < this.floorObjList.length; i++) {
            this.floorList.push(this.floorObjList[i].dz);
          }
          regList[index].regValue = this.floorList[0] || '';
        }
      }
      this.regList = regList;
    },
    chooseImg(){
        console.log("in chooseImg")
        let that = this;
        wx.ready(()=>{
          wx.chooseImage({
            count: 1, // 默认9
            sizeType: ['original'], // 可以指定是原图还是压缩图，默认二者都有
            // sourceType: ['camera'], // 可以指定来源是相册还是相机，默认二者都有
            success: function (res) {
              console.log(res)
              wx.uploadImage({
                localId: res.localIds[0],
                isShowProgressTips: 1,
                success: function (ret) {
                  // 返回图片的服务器端ID
                  var serverId = ret.serverId;
                  that.uploadWapFace(serverId)
                }
              })
            },
            fail: function (res){
              alert(JSON.stringify(res))
            }
          })
        })
      },
    uploadWapFace(id){
      let params = {
        mediaId:id,
        marketId:this.common.marketInfo.id
      }
      util.showLoading();
      uploadWapFace(params).then(res=>{
        console.log(res)
        if(res.res && res.res.code === 10000 && res.body){
          util.hideLoading()
          if(res.body.isValid){
            this.imageUrl = res.body.imgUrl
          }else{
            util.showToast(res.body.errMsg)
          }
        }else{
          util.showToast('图片上传失败')
          util.hideLoading()
        }
      })
    },
  },
  filters: {
    place(value) {
      return "请输入" + value;
    },
    labelFilter: function(value, activeTab) {
      if (activeTab) {
        switch (value) {
          case "examine_user_name":
            return "我的信息";
          case "visitor_company":
            return "我的公司";
          case "visitor_floor":
            return "来访楼层";
          case "visitor_date":
            return "来访日期";
          case "visitor_user_name":
            return "访客姓名";
          case "visitor_mobile":
            return "访客电话";
          case "visitor_type":
            return "来访事由";
          case "visitor_num":
            return "来访人数";
          case "visitor_face_url":
            return "访客人脸";
          case "visitor_peer":
            return "同行人"
          default:
        }
      } else {
        switch (value) {
          case "examine_user_name":
            return "受访人信息";
          case "visitor_company":
            return "拜访公司";
          case "visitor_floor":
            return "拜访楼层";
          case "visitor_date":
            return "拜访日期";
          case "visitor_user_name":
            return "访客姓名";
          case "visitor_mobile":
            return "访客电话";
          case "visitor_type":
            return "拜访事由";
          case "visitor_num":
            return "拜访人数";
          case "visitor_peer":
            return "同行人"
          default:
        }
      }
    }
  },
  watch: {
    activeTab: function() {
      this.userInfo = "";
      this.companyName = "";
      this.regList = "";
      this.date = util.formatTime(new Date(), 10);
      this.type = "";
      this.visitorId = "", this.idTypeList = [];
      util.showLoading();
      this.getVisitorRegByParams("tabClick");
    }
  }
};
</script>

<style lang="less" scoped>
@import "../../assets/css/common.less";
.wrapper {
  background-color: @colore;
}
.wrapper_theme_3{
  background-color:#ffffff;
  
}
.formBox {
  width: 100%;
  margin-bottom: 130px;
}
//tabbox
.tabBox {
  width: 100%;
  height: 88px;
  .flex();
  justify-content: center;
  align-items: center;
  .tabText {
    display: block;
    height: 88px;
    line-height: 88px;
    font-size: 32px;
    color: @color9;
    flex: 1;
    text-align: center;
    position: relative;
    &:after {
      position: absolute;
      content: "";
      left: 50%;
      bottom: 0;
      width: 32px;
      height: 6px;
      margin-left: -16px;
      background: @colore;
    }
  }
  .activeTab {
    color: rgba(51, 51, 51, 1);
    &:after {
      background: @color17;
    }
  }
  
  .tabText_theme_3{
    display: block;
    height: 88px;
    line-height: 88px;
    font-size: 32px;
    color: @color9;
    flex: 1;
    text-align: center;
    position: relative;
    &:after {
      position: absolute;
      content: "";
      left: 50%;
      bottom: 0;
      width: 200px;
      height: 6px;
      margin-left: -100px;
      background: #ffffff;
    }
  }
  .activeTab_theme_3{
    color: #9a8162;
    &:after {
      background:#9a8162;
    }
  }

 
}

.remarksBox {
  width: 100%;
  position: relative;
  padding: 20px 0 28px;
  span {
    position: absolute;
  }
  .inviteText {
    left: 25%;
    margin-left: -64px;
    font-size: 24px;
    color: #999;
    line-height: 32px;
  }
  .visitText {
    right: 25%;
    margin-right: -64px;
    font-size: 24px;
    color: rgba(153, 153, 153, 1);
    line-height: 32px;
  }

  .remarkView{
    width: 100%;
    flex-direction: column;
    align-items: center;
    display: flex;
    .remarkText{
      margin-top:40px;
      font-size: 48px;
      font-weight: 400;
      line-height: 68px;
      text-align: center;
    


    }
    .remarkText2{
      font-family: PingFang SC;
      font-size: 36px;
      font-weight: 400;
      line-height: 50px;
      margin-top:24px;
      margin-bottom: 40px;

    }

  }
}
// form box
.form {
  margin: 0 20px;
  padding: 0 28px 0 20px;
  background-color: rgba(255, 255, 255, 1);
  box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.06);
  border-radius: 8px;
  .border();
  overflow: hidden;
  .faceBox{
     min-height: 200px;
    .flex();
    justify-content: space-between;
    align-items: center;
    width: 100%;
    .borderB();
    &:last-child {
      border: 0;
    }
  }
  .faceBoxRight {
    .flex();
    min-height: 200px;
    align-items: center;
    width: 436px;
    justify-content: space-between;
    .imageBg{
      margin-top:20px;
      width:200px;
      height:200px;
      padding:20px;
      // box-sizing:border-box;
      position:relative;
      // box-shadow:0px 4px 40px 0px rgba(0,91,165,0.29);
      // border-radius:8px;
      overflow:hidden;
      // background:#fff;
      // z-index:3;
    }
    .paiIcon{
        width:160px;
        height:160px;
    }
  }

  .nameBox {
    min-height: 100px;
    .flex();
    justify-content: space-between;
    align-items: center;
    width: 100%;
    .borderB();
    &:last-child {
      border: 0;
    }
  }
  .nameBox_flex{
    .nameBoxLeft{
      flex:1;
    }
    .nameBoxRight{
      width:auto;
    }
  }
  .nameCardLeft {
    width: 216px;
    min-height: 100px;
    .flex();
    // justify-content: space-between;
    align-items: center;
    .xin {
      color: #fc3f56;
      margin-right: 4px;
      display: block;
    }
    .label {
      font-size: 28px;
      color: rgba(51, 51, 51, 1);
    }
  }
  .nameCardRight {
    flex: 1;
    // height: 144px;
    padding: 30px 0;
    margin-right: 10px;
    .flex();
    align-items: center;
    justify-content: space-between;
    .value {
      flex: 1;
      padding-right: 14px;
      text-overflow: ellipsis;
      white-space: nowrap;
      font-size: 28px;
      color: #000;
      display: block;
    }
  }
  .nameBoxLeft {
    width: 216px;
    min-height: 100px;
    .flex();
    align-items: center;
    .xin {
      color: #fc3f56;
      margin-right: 4px;
      display: block;
    }
    .label {
      font-size: 28px;
      color: rgba(51, 51, 51, 1);
    }
    > img {
      margin-left: 16px;
    }
  }
  .nameBoxRight {
    .flex();
    min-height: 100px;
    align-items: center;
    width: 436px;
    justify-content: space-between;
    .placeholder {
      font-size: 28px;
      color: rgba(201, 201, 201, 1);
    }
    .value {
      max-width: 400px;
      min-height: 100px;
      line-height: 100px;
      padding-right: 14px;
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
      font-size: 28px;
      color: #000;
    }
  }
  .nameCardRightLeft {
    .flex();
    flex-direction: column;
    justify-content: space-between;
    flex: 1;
    .companyCard {
      .flex();
    }
    .companyLabel {
      font-size: 24px;
      color: rgba(153, 153, 153, 1);
      line-height: 34px;
      padding-right: 14px;
    }
    .companyText {
      font-size: 24px;
      color: rgba(51, 51, 51, 1);
      line-height: 34px;
      flex: 1;
    }
  }

  .borderRight {
    height: 100px;
    border-right-width: 1px;
    border-right-color: #eaeaea;
  }
}
.form_theme_3{
  margin: 0 20px;
  padding: 0 28px 0 20px;
  background-color: rgba(255, 255, 255, 1);
  overflow: hidden;
  .faceBox{
     min-height: 200px;
    .flex();
    justify-content: space-between;
    align-items: center;
    width: 100%;
    .borderB();
    &:last-child {
      border: 0;
    }
  }
  .faceBoxRight {
    .flex();
    min-height: 200px;
    align-items: center;
    width: 436px;
    justify-content: space-between;
    .imageBg{
      margin-top:20px;
      width:200px;
      height:200px;
      padding:20px;
      // box-sizing:border-box;
      position:relative;
      // box-shadow:0px 4px 40px 0px rgba(0,91,165,0.29);
      // border-radius:8px;
      overflow:hidden;
      // background:#fff;
      // z-index:3;
    }
    .paiIcon{
        width:160px;
        height:160px;
    }
  }

  .nameBox {
    min-height: 100px;
    .flex();
    justify-content: space-between;
    align-items: center;
    width: 100%;
    border-bottom: 2px solid #BDBDBD;
   
  }
  .nameBox_flex{
    .nameBoxLeft{
      flex:1;
    }
    .nameBoxRight{
      width:auto;
    }
  }
  .nameCardLeft {
    width: 216px;
    min-height: 100px;
    .flex();
    // justify-content: space-between;
    align-items: center;
    .xin {
      color: #fc3f56;
      margin-right: 4px;
      display: block;
    }
    .label {
      font-size: 28px;
      color: rgba(51, 51, 51, 1);
    }
  }
  .nameCardRight {
    flex: 1;
    // height: 144px;
    padding: 30px 0;
    margin-right: 10px;
    .flex();
    align-items: center;
    justify-content: space-between;
    .value {
      flex: 1;
      padding-right: 14px;
      text-overflow: ellipsis;
      white-space: nowrap;
      font-size: 28px;
      color: #000;
      display: block;
    }
  }
  .nameBoxLeft {
    width: 216px;
    min-height: 100px;
    .flex();
    align-items: center;
    .xin {
      color: #fc3f56;
      margin-right: 4px;
      display: block;
    }
    .label {
      font-size: 28px;
      color: rgba(51, 51, 51, 1);
    }
    > img {
      margin-left: 16px;
    }
  }
  .nameBoxRight {
    .flex();
    min-height: 100px;
    align-items: center;
    width: 436px;
    justify-content: space-between;
    .placeholder {
      font-size: 28px;
      color: rgba(201, 201, 201, 1);
    }
    .value {
      max-width: 400px;
      min-height: 100px;
      line-height: 100px;
      padding-right: 14px;
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
      font-size: 28px;
      color: #000;
    }
  }
  .nameCardRightLeft {
    .flex();
    flex-direction: column;
    justify-content: space-between;
    flex: 1;
    .companyCard {
      .flex();
    }
    .companyLabel {
      font-size: 24px;
      color: rgba(153, 153, 153, 1);
      line-height: 34px;
      padding-right: 14px;
    }
    .companyText {
      font-size: 24px;
      color: rgba(51, 51, 51, 1);
      line-height: 34px;
      flex: 1;
    }
  }

  .borderRight {
    height: 100px;
    border-right-width: 1px;
    border-right-color: #eaeaea;
  }

}
.footer_box {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  height: 108px;
  padding: 16px 28px;
  box-sizing: border-box;
  
  .btn_default {
    width: 100%;
    height: 76px;
    text-align: center;
    line-height: 76px;
    font-size: 32px;
    color: #fff;
    background: #dadada;
  }
  .btn_primary {
    background: @color17;
  }
  .btn_primary_theme_3{
    background:  rgba(161, 128, 93, 1)
  }
}
.input {
  flex: 1;
  font-size: 28px;
  height: 98px;
  // line-height: 100px;
  /* padding-left: 14px; */
}

.yjt {
  width: 15px;
  height: 26px;
}

.historyView{
  margin-top: 28px;
  flex-direction: row;
  width: 100%;
  display: flex;
  justify-content: flex-end;
  
}
.goHistory {
  font-size: 26px;
  color: @color17;
  line-height: 32px;
  padding-right: 32px;
  text-align: right;
}
.bottom_box_theme_3{
  margin-top:68px;
  width: 100%;
  align-items: center;
  display: flex;
  flex-direction: column;
  .remarkView{
    width: 100%;
    flex-direction: column;
    align-items: center;
    display: flex;
    .remarkText{
      padding-right: 10px;
      padding-left: 10px;
      
      font-size: 28px;
      font-weight: 400;
      line-height: 40px;
      text-align: center;
      text-underline-position: from-font;
      text-decoration-skip-ink: none;
      background: rgba(154, 129, 98, 0.1);

      color: #9A8162;

      text-align: center;
    }
  }
  .historyView{
    margin-top: 10px;
    flex-direction: row;
    width: 100%;
    display: flex;
    justify-content: center;
  }
  .goHistory_theme_3{
    margin-left: 20px;
    font-family: PingFang SC;
    font-size: 28px;
    font-weight: 400;
    line-height: 40px;
    text-align: left;
    color: #9A8162;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;
    margin-bottom: 28px;
    text-decoration: underline;
    

  }

}

.bottomButton {
  width: 100%;
  height: 108px;
  background-color: rgba(255, 255, 255, 1);
  justify-content: center;
  align-items: center;
}

.bottomButtonActive {
  width: 694px;
  height: 76px;
  background-color: rgba(0, 135, 255, 1);
  border-radius: 8px;
  font-size: 34px;
  font-family: PingFangSC-Medium;
  font-weight: 500;
  color: rgba(255, 255, 255, 1);
  line-height: 76px;
  text-align: center;
}

.cantGo {
  width: 694px;
  height: 76px;
  background-color: rgba(218, 218, 218, 1);
  border-radius: 8px;
  font-size: 34px;
  font-family: PingFangSC-Medium;
  font-weight: 500;
  color: rgba(255, 255, 255, 1);
  line-height: 76px;
  text-align: center;
}
.no_mess {
  text-align: center;
  p {
    height: 44px;
    font-size: 32px;
    color: rgba(153, 153, 153, 1);
    line-height: 44px;
    margin: 188px auto 60px;
  }
  .history_text {
    margin: 0;
    height: 32px;
    font-size: 28px;
    color: rgba(23, 64, 218, 1);
    line-height: 32px;
  }
  img {
    display: block;
    width: 100%;
    height: auto;
    margin-top: 300px;
    margin-bottom: 100px;
  }
}
</style>
